<div class="form-group">
    <input id="autocomplete-address" type="text" [(ngModel)]="address" class="form-control" placeholder="{{ 'HOME.placeHolderAddress' | translate }}">
</div>